import React from "react";
import { graphql, StaticQuery } from 'gatsby';
import { FaFacebookSquare, FaTwitter, FaInstagram, FaFlickr, FaEnvelope } from 'react-icons/fa';

const getCurrentYear = () => {
    return new Date().getFullYear();
};

export default () => (
    <StaticQuery
        query={graphql`
      query FooterQuery {
        allAirtable(filter: {table: {eq: "data"}, data: {cover: {eq: true}, publish: {eq: true}}}, sort: {fields: data___published_date, order: DESC}) {
            nodes {
                recordId
                data {
                    story
                    slug
                }
            }
        }
      }
    `}
        render={data => (
            <footer className="modern-footer">
                <div className="footer-accent"></div>
                <div className="footer-main">
                    <div className="container">
                        <div className="footer-grid">
                            {/* Brand column */}
                            <div className="footer-brand-col">
                                <a href="/" className="footer-brand">
                                    <img src="/oc-logo.png" alt="Oberlin College and Conservatory" />
                                </a>
                                <p className="footer-tagline">
                                    Capturing campus life through immersive visual storytelling.
                                </p>
                                <div className="footer-social">
                                    <a href="https://www.facebook.com/OberlinCollege/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                        <FaFacebookSquare />
                                    </a>
                                    <a href="https://twitter.com/oberlincollege" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                                        <FaTwitter />
                                    </a>
                                    <a href="https://www.instagram.com/oberlincollege/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                        <FaInstagram />
                                    </a>
                                    <a href="https://www.flickr.com/photos/oberlin/albums" target="_blank" rel="noopener noreferrer" aria-label="Flickr">
                                        <FaFlickr />
                                    </a>
                                    <a href="mailto:webteam@oberlin.edu" aria-label="Email">
                                        <FaEnvelope />
                                    </a>
                                </div>
                            </div>

                            {/* Stories column */}
                            <div className="footer-stories-col">
                                <h3 className="footer-heading">Stories</h3>
                                <ul className="footer-links">
                                    {data.allAirtable.nodes.map(node => (
                                        <li key={node.recordId}>
                                            <a href={node.data.slug}>{node.data.story}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="container">
                        <p>&copy; {getCurrentYear()} Oberlin College and Conservatory. All rights reserved.</p>
                    </div>
                </div>
            </footer>
        )}
    />
)
